import styled from "styled-components";

const ConfirmTitle = styled.div`
	font-size: 28px;
	font-weight: bold;
`

export default ConfirmTitle;